/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isuserallowedtotogglecamera5Inputs */

const en_entity_isuserallowedtotogglecamera5 = /** @type {(inputs: Entity_Isuserallowedtotogglecamera5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is User Allowed To Toggle Camera`)
};

const de_entity_isuserallowedtotogglecamera5 = /** @type {(inputs: Entity_Isuserallowedtotogglecamera5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer darf Kamera umschalten`)
};

/**
* | output |
* | --- |
* | "Is User Allowed To Toggle Camera" |
*
* @param {Entity_Isuserallowedtotogglecamera5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isuserallowedtotogglecamera5 = /** @type {((inputs?: Entity_Isuserallowedtotogglecamera5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isuserallowedtotogglecamera5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isuserallowedtotogglecamera5(inputs)
	return de_entity_isuserallowedtotogglecamera5(inputs)
});
export { entity_isuserallowedtotogglecamera5 as "entity_isUserAllowedToToggleCamera" }